import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { Capacitor } from '@capacitor/core';
import packageInfo from '../../package.json';

let bugsnagClient = null;
let bugsnagVuePlugin = null;

// Only initialize Bugsnag on native platforms (not web)
if (Capacitor.getPlatform() !== 'web') {
  const apiKey = process.env.BUGSNAG_API_KEY;
  
  if (apiKey && apiKey !== '""' && apiKey !== '') {
    try {
      // Start Bugsnag error tracking
      bugsnagClient = Bugsnag.start({
        apiKey: apiKey,
        plugins: [new BugsnagPluginVue()],
        appVersion: packageInfo.version,
        releaseStage: process.env.NODE_ENV === 'production' ? 'production' : 'development',
        collectUserIp: false,
        onError: (event) => {
          // Add additional metadata if needed
          event.addMetadata('app', {
            version: packageInfo.version,
            build: packageInfo.appBuild
          });
        }
      });
      
      // Note: Performance monitoring is not currently configured for this application.
      // Only error monitoring via Bugsnag is enabled.
      
      // Get the Vue plugin for Vue 2 error handler installation
      bugsnagVuePlugin = Bugsnag.getPlugin('vue');
      
    } catch (error) {
      console.error('Failed to initialize Bugsnag:', error);
    }
  } else {
    console.warn('Bugsnag API key not configured. Error tracking will be disabled.');
  }
}

export default bugsnagClient;
export { bugsnagVuePlugin };

// Helper functions for setting user context
export const setBugsnagUser = (user) => {
  if (bugsnagClient && Capacitor.getPlatform() !== 'web') {
    bugsnagClient.setUser(user.id || null, user.email || null, user.name || null);
  }
};

export const clearBugsnagUser = () => {
  if (bugsnagClient && Capacitor.getPlatform() !== 'web') {
    bugsnagClient.setUser(null, null, null);
  }
};

// Helper function to notify Bugsnag of errors
export const notifyBugsnag = (error, metadata = {}) => {
  if (bugsnagClient && Capacitor.getPlatform() !== 'web') {
    bugsnagClient.notify(error, (event) => {
      if (metadata && Object.keys(metadata).length > 0) {
        Object.keys(metadata).forEach(key => {
          event.addMetadata(key, metadata[key]);
        });
      }
    });
  }
};

